import Link from "next/link";

export default function LegalFooter() {
  return (
    <footer className="mt-12 border-t border-gray-100 pt-6 pb-8 text-center text-xs text-gray-400">
      <nav className="flex flex-wrap justify-center gap-x-4 gap-y-2 mb-3">
        <Link href="/legal/impressum" className="hover:text-gray-700 hover:underline">
          Impressum
        </Link>
        <Link href="/legal/datenschutz" className="hover:text-gray-700 hover:underline">
          Datenschutz
        </Link>
        <Link href="/legal/nutzungsbedingungen" className="hover:text-gray-700 hover:underline">
          Nutzungsbedingungen
        </Link>
        <Link href="/legal/credits" className="hover:text-gray-700 hover:underline">
          Credits
        </Link>
        <Link href="/help" className="hover:text-gray-700 hover:underline">
          Hilfe
        </Link>
      </nav>
      <p>KidChat — ein privates, nicht-kommerzielles Projekt.</p>
    </footer>
  );
}
